import {
  PostRecomendationInterface,
  DeleteRecomendationInterface,
} from '@/data/payload/contracts/RecomendationRequest'

export class DeleteRecomendationRequest
  implements DeleteRecomendationInterface {
  private contentType: string
  private contentId: number

  constructor(contentType: string, contentId: number) {
    ;(this.contentType = contentType), (this.contentId = contentId)
  }
  public toJSON() {
    const Ids = [
      {
        content_type: this.contentType,
        content_id: this.contentId,
      },
    ]
    return JSON.stringify({
      Ids,
    })
  }
}

export class RecomendationApiRequest implements PostRecomendationInterface {
  private contentId: number
  private contentType: string

  constructor(contentId: number, contentType: string) {
    this.contentId = contentId
    this.contentType = contentType
  }

  public toJSON() {
    const data = {
      content_id: this.contentId,
      content_type: this.contentType,
    }

    return JSON.stringify({
      data,
    })
  }
}
